import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { type DocsPage, resolveDocsLanguage } from "@/lib/docsPages";
import { colors } from "@/theme/colors";

// フッターリンク。i18n キー (表示ラベル) と、遷移先ページ (index.ts の docsRoute が配信
// する public/docs/{lng}/{page}.html) の組を持つ (JPTP_CANSEI-1345)。実コンテンツが用意
// されていない言語は resolveDocsLanguage が英語にフォールバックする (JPTP_CANSEI-1350)。
const FOOTER_LINKS: ReadonlyArray<{ key: string; page: DocsPage }> = [
  { key: "footer.privacyPolicy", page: "privacy-policy" },
  { key: "footer.termsOfService", page: "terms-of-service" },
  { key: "footer.specifiedCommercialTransactions", page: "specified-commercial-transactions" },
  { key: "footer.faq", page: "faq" },
];

export function Footer() {
  const { t, i18n } = useTranslation();
  return (
    <Box
      component="footer"
      className="guest-footer"
      sx={{
        bgcolor: "primary.main",
        py: { xs: 3, sm: 4 },
        px: { xs: 2, sm: 3, md: 4 },
      }}
    >
      {/* リンク群: SP=1列, Tablet=2列, PC=4列 */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(4, 1fr)",
          },
          rowGap: { xs: 1.5, sm: 2 },
          columnGap: { xs: 0, sm: 2 },
          mb: 3,
        }}
      >
        {FOOTER_LINKS.map(({ key, page }) => (
          <ButtonBase
            key={key}
            component="a"
            href={`/docs/${resolveDocsLanguage(page, i18n.language)}/${page}.html`}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              justifyContent: "flex-start",
              fontSize: { xs: 15, sm: 16 },
              color: colors.footerText,
              "&:hover": { color: colors.footerTextHover, textDecoration: "underline" },
              "&:focus-visible": {
                outline: "2px solid",
                outlineColor: colors.gold,
                outlineOffset: 2,
              },
            }}
          >
            {t(key)}
          </ButtonBase>
        ))}
      </Box>

      {/* コピーライト */}
      <Typography
        sx={{
          fontSize: 13,
          color: colors.footerText,
        }}
      >
        © {new Date().getFullYear()} Japanticket Asia Pacific Pte. Ltd. All rights reserved.
      </Typography>
    </Box>
  );
}
